import { render } from "./DemandTemplateForm.vue?vue&type=template&id=48d2edf8"
import script from "./DemandTemplateForm.vue?vue&type=script&lang=ts"
export * from "./DemandTemplateForm.vue?vue&type=script&lang=ts"
script.render = render

export default script